import React, { useEffect, useState } from "react";
import { AgentConfig, AgentViewModel } from "./AgentsStore";
import { Box, Grid, ResponsiveContext, Text } from "grommet";
import AgentControls from "./AgentControls";

const AgentTile = ({ agent, onAction, config }: { agent: AgentViewModel; onAction: Function; config?: AgentConfig }) => {
    const [columns, setColumns] = useState(!config ? ["250px", "120px", "120px", "120px", "120px"] : ["250px", "300px", "120px", "120px", "120px", "120px"]);

    const [rows, setRows] = useState(["auto"]);
    const size = React.useContext(ResponsiveContext);

    useEffect(() => {
        let temp = [...columns];
        if (size === "small") {
            setColumns(rows);
            setRows(temp);
        }
    }, [size]);

    return agent ? (
        <Grid columns={columns} gap="small" pad={"small"}>
            <Text color={"brand"} size="small">{agent.name}</Text>
            <AgentControls config={config} onChange={(config) => onAction(config)}></AgentControls>
        </Grid>
    ) : (
        <></>
    );
};

export default AgentTile;
